import React, { useState, useEffect } from 'react';
import { EncodeData } from '../shared/Aes';
import ImageModal from '../../components/modal/ImageModal';

function StocknameConverter(props) {
    const PUBLIC_URL = process.env.PUBLIC_URL;
    let colorCode = "#FFFFFF";
    let colorChars = props.itemname.substring(0, 2);
    let remainingChars = props.itemname.substring(2);
    let imageurl = "";
    let imageurl2 = "";
    let motionitempreviewurl = "";

    let image_Generatation_Status = props.image_Generatation_Status;
    let lang = props.lang;
    
    //console.log(props.itempreviewurl);

      //Add model image preview 2025-11-28
    // 控制 modal 開關
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Device type: true = mobile / tablet / small screen, false = desktop
    const [isMobile, setIsMobile] = useState(false);
    // const [deviceType, setDeviceType] = useState('Unknown');
    const [modalPreviewImageUrl, setModalPreviewImageUrl] = useState('');

    useEffect(() => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(ua);
        const isSmallScreen = window.innerWidth < 1024;

        const mobile = isSmallScreen;
        setIsMobile(mobile);
        // setDeviceType(mobile ? 'Mobile / Tablet' : 'Desktop');

        // For console testing
        console.log('UserAgent:', ua);
        console.log(
        'Detected device type:',
        mobile ? 'Mobile / Tablet' : 'Desktop'
        );
    }, []);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

  //add model image preview 2025-11-28

    const [isPreview, setPreview] = useState(false);
    const [images, setImages] = useState([]);

    const isRedPacketEvent = props.isRedPacketEvent ?? false;
    let event_RedPacket = "20251204_red_packet/";
    
    const handlePreview = (imageUrl, remarks, isMotion) => {

        //console.log("handlePreview = (imageUrl, remarks, isMotion) " + imageUrl + "/" + remarks + "/" +  isMotion);

        if (isMotion || lang === "NA" || remarks === "")
        {   
            var encodedPreviewUrl = decodeURIComponent(EncodeData(imageUrl));
            
            //window.open( PUBLIC_URL + '/event-image?srcUrl=' + encodedPreviewUrl);
            //   window.open(imageUrl, '_blank');
            console.log('StockNameConverter1');

            //add code 2025-11-28
            if (isMobile) {
                setModalPreviewImageUrl(imageUrl);
                openModal();
            } else {
                window.open(imageUrl, '_blank');
            }
        }
        else
        {
            //console.log("image_Generatation_Status: (STOCKNAME) " + image_Generatation_Status);

            if (image_Generatation_Status === "" || image_Generatation_Status !== "Complete")
            {
                props.handlePreviewTask(imageUrl);
            }
            else
            {
                var encodedPreviewUrl = decodeURIComponent(EncodeData(imageUrl));
               
                //window.open( PUBLIC_URL +  '/event-image?srcUrl=' + encodedPreviewUrl);
                // window.open(imageUrl, '_blank');
                console.log('StockNameConverter2');

                //add code 2025-11-28
                if (isMobile) {
                setModalPreviewImageUrl(imageUrl);
                openModal();
                } else {
                window.open(imageUrl, '_blank');
                }
            }
        }

      };



    if (props.itemname.includes("中東")) {
        colorCode = "green";
        imageurl = process.env.REACT_APP_URL_IMAGE + "me-1.jpg";
        imageurl2 = process.env.REACT_APP_URL_IMAGE + "me-2.jpg";
    } else if (props.itemname.includes("開心果")) {
        colorCode = "blue";
        
        if (props.itemname.includes("蛇年開心果"))
        {
            imageurl = process.env.REACT_APP_URL_IMAGE + "us-1.jpg";
        }
    } else if (isRedPacketEvent)
    {
        if (props.itemname.includes("款式A")) {
            colorCode = "blue";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket + "redpacket01.jpg";
        } else if (props.itemname.includes("款式B")) {
            colorCode = "green";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket02.jpg";
        } else if (props.itemname.includes("款式C")) {
            colorCode = "blue";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket03.jpg";
        } else if (props.itemname.includes("款式D")) {
            colorCode = "green";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket04.jpg";
        } else if (props.itemname.includes("款式E")) {
            colorCode = "blue";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket05.jpg";
        } else if (props.itemname.includes("款式F")) {
            colorCode = "green";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket06.jpg";
        } else if (props.itemname.includes("款式G")) {
            colorCode = "blue";
            imageurl = process.env.REACT_APP_URL_IMAGE_HOST + event_RedPacket  + "redpacket07.jpg";
            motionitempreviewurl = process.env.REACT_APP_RED_PACKET_EVENT_MOTION_IMAGE_URL;
        } else {
            colorCode = "black";
        }

    }
    else
    {
        colorCode = "black";
    }
    

    return (
        <>
            {imageurl && <img src={imageurl} alt="Stock Image" />}
            {imageurl2 && <img src={imageurl2} alt="Stock Image" />}
            
                {
                    isRedPacketEvent &&
                    <span>&nbsp;&nbsp;
                        <button type="button" style={{ backgroundColor: '#F4405F', color: '#FFFFFF', border:'none' }} onClick={() => handlePreview(props.itempreviewurl,props.remarks,false)}>印刷預覽</button>
                        &nbsp;&nbsp;
                        {motionitempreviewurl && <button type="button" style={{ backgroundColor: '#F4405F', color: '#FFFFFF', border:'none' }} onClick={() => handlePreview(motionitempreviewurl,props.remarks,true)}>動態預覽</button>}
                        <div style={{ marginTop: '1rem' }}>
                            <ImageModal
                                isOpen={isModalOpen}
                                src={modalPreviewImageUrl}
                                onClose={closeModal}
                            />
                        </div>
                    <br></br>    
                    </span> 
                }

            <span style={{ color: colorCode }}> {colorChars}{remainingChars}{props.itemspec}</span>
            <span></span>
        

        </>
    );
}

export default StocknameConverter;